export default "__VITE_ASSET__B50wGfd7__"